import { Component, computed, input, output, signal } from '@angular/core';
import { TRule } from '../../components/rid-functional-syllabic-keyboard/rid-functional-syllabic-keyboard';
import { TOption } from '../../components/rid-option/rid-option';
import { TKeyValue, keyboardGroups } from '../../components/rid-syllabic-keyboard/rid-syllabic-keyboard.utils';
import { RidSyllabicKeyboardAssignments } from '../rid-syllabic-keyboard-assignments/rid-syllabic-keyboard-assignments';

@Component({
  selector: 'rid-multisyllabic-keyboard-choose-rule',
  imports: [RidSyllabicKeyboardAssignments],
  templateUrl: './rid-multisyllabic-keyboard-choose-rule.html',
  host: {
    class: 'block',
  },
})
export class RidMultisyllabicKeyboardChooseRule {
  prompts = input.required<{ prompt: TOption; answer: TKeyValue[] }[]>();

  isChoosingRule = signal(false);
  mask = computed<TKeyValue[] | undefined>(() =>
    this.isChoosingRule()
      ? (['→', '←', '-', '+'] as const)
      : [
          ...keyboardGroups['KLINKERS'],
          ...keyboardGroups['LANGE_KLINKERS'],
          ...keyboardGroups['KORTE_LANGE_KLINKERS'],
          ...keyboardGroups['DUBBELE_KLINKERS'],
          ...keyboardGroups['DRIEDUBBELE_KLINKERS'],
          ...keyboardGroups['VIERDUBBELE_KLINKERS'],
          ...keyboardGroups['MEDEKLINKERS'],
          ...keyboardGroups['SJWAS'],
        ].map((k) => k.value),
  );

  finished = output<void>();

  onAppliedRule(rule: TRule) {
    this.isChoosingRule.set(rule.name === 'VRAAGTEKEN');
  }
}
